(function() {
  'use strict';

  var HELP_SELECTOR = '[data-bb-i2-measurement-help]';
  var FIELD_SELECTOR = 'input[name="properties[Custom Joint Size (Caliper Measurement)]"]';
  var syncFrame = null;

  function mountMeasurementField(help) {
    var form = help.closest('form');
    var target = help.querySelector('[data-bb-i2-measurement-field]');

    if (!form || !target) {
      return;
    }

    var inputs = form.querySelectorAll(FIELD_SELECTOR);
    var mountedInput = target.querySelector(FIELD_SELECTOR);
    var input = null;

    for (var i = 0; i < inputs.length; i += 1) {
      if (inputs[i].closest('.bold_options')) {
        input = inputs[i];
        break;
      }
    }

    input = input || mountedInput || inputs[0];

    if (mountedInput && input && mountedInput !== input) {
      if (mountedInput.value.trim() !== '' && input.value.trim() === '') {
        input.value = mountedInput.value;
      }

      var mountedRow = mountedInput.closest('.bold_option');
      if (mountedRow) {
        mountedRow.remove();
      }
    }

    var row = input && input.closest ? input.closest('.bold_option') : null;

    if (row && row.parentNode !== target) {
      target.appendChild(row);
    }

    var duplicateInputs = target.querySelectorAll(FIELD_SELECTOR);
    for (var duplicateIndex = 0; duplicateIndex < duplicateInputs.length; duplicateIndex += 1) {
      if (duplicateInputs[duplicateIndex] === input) {
        continue;
      }

      var duplicateRow = duplicateInputs[duplicateIndex].closest('.bold_option');
      if (duplicateRow) {
        duplicateRow.remove();
      }
    }

    var submitGroup = form.querySelector('.product-form__controls-group--submit');
    if (submitGroup && submitGroup.nextElementSibling !== help) {
      submitGroup.insertAdjacentElement('afterend', help);
    }
  }

  function scheduleMount(help) {
    if (syncFrame !== null && window.cancelAnimationFrame) {
      window.cancelAnimationFrame(syncFrame);
    }

    var run = function() {
      syncFrame = null;
      mountMeasurementField(help);
    };

    if (window.requestAnimationFrame) {
      syncFrame = window.requestAnimationFrame(run);
      return;
    }

    window.setTimeout(run, 0);
  }

  function initHelp(help) {
    if (!help || help.__bbI2MeasurementGuideInitialized) {
      return;
    }

    help.__bbI2MeasurementGuideInitialized = true;

    var form = help.closest('form');
    if (!form) {
      return;
    }

    if (window.MutationObserver) {
      var observer = new MutationObserver(function() {
        scheduleMount(help);
      });

      observer.observe(form, {
        childList: true,
        subtree: true
      });
    }

    if (
      window.BOLD &&
      window.BOLD.common &&
      window.BOLD.common.eventEmitter &&
      window.BOLD.common.eventEmitter.on
    ) {
      window.BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function() {
        scheduleMount(help);
      });
    }

    window.addEventListener('pageshow', function() {
      scheduleMount(help);
    });

    scheduleMount(help);
  }

  function init() {
    initHelp(document.querySelector(HELP_SELECTOR));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
